// styles
import "../themes/common.scss";
import "../themes/css/pages/blog.scss";
//js
import "../themes/js/common.js";
import "../themes/js/pages/blog.js";

import { initmanage } from "../javascripts/component/manage.js";

initmanage();

